// extracted by mini-css-extract-plugin
export default {"personalDataProcessingModal":"css_personalDataProcessingModal__9OVsh","title":"css_title__hphxR","scrollableContent":"css_scrollableContent__TsBPa"};